import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

export const GREGORIAN_DATE_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-gregorian-user-data-input',
  template: `
    <div [formGroup]="formGroupParent">
      <mat-form-field appearance="outline" color="accent" class="full-width">
        <input
          matInput
          [formControlName]="controlName"
          [matDatepicker]="datePicker"
          autocomplete="off"
          [readonly]="readonly"
        />
        <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
        <mat-datepicker #datePicker></mat-datepicker>
      </mat-form-field>
    </div>
  `,
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: GREGORIAN_DATE_FORMATS,
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'ar',
    },
  ]
})
export class GregorianUserDataInputComponent implements OnInit {
  @Input() formGroupParent: FormGroup;
  @Input() mode: any;
  @Input() userData: any;
  @Input() inputType: any;
  @Input() controlName: string;
  @Input() maxValue: string;
  @Input() readonly = false;
  @Input() listData: string[];

  ngOnInit() {}
}
